import { render } from "./AddCustomerProductGroupView.vue?vue&type=template&id=5b3566b0"
import script from "./AddCustomerProductGroupView.vue?vue&type=script&lang=js"
export * from "./AddCustomerProductGroupView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__